module.exports = __webpack_public_path__ + "static/assets/db4179005e9e4d9c93683a6512e3bf2c.png";